// Proposal Workflow Models

export enum FreelancerProposalStatus {
  NotSubmitted = "NotSubmitted",
  SubmittedCSM = "SubmittedCSM",
  InDiscussionWithCSM = "InDiscussionWithCSM",
  InDiscussionWithClient = "InDiscussionWithClient",
  RevisedForCSM = "RevisedForCSM",
  RevisedForClient = "RevisedForClient",
  SubmittedClient = "SubmittedClient",
  CastingToSchedule = "CastingToSchedule",
  CastingScheduled = "CastingScheduled",
  Accepted = "Accepted",
  RefusedTalent = "RefusedTalent",
  RefusedClient = "RefusedClient",
  Cancelled = "Cancelled"
}

export enum ProposalWorkflowAction {
  Submit = "Submit",
  TransmitToClient = "TransmitToClient",
  RequestRevision = "RequestRevision",
  Revise = "Revise",
  Accept = "Accept",
  RefuseByClient = "RefuseByClient",
  RefuseByTalent = "RefuseByTalent",
  RequestCasting = "RequestCasting",
  ScheduleCasting = "ScheduleCasting",
  Cancel = "Cancel"
}

export interface WorkflowTransitionResult {
  isSuccess: boolean;
  proposalId: number;
  projectId: number;
  oldStatus: FreelancerProposalStatus;
  newStatus: FreelancerProposalStatus;
  requiresProjectStatusChange: boolean;
  suggestedProjectStatus?: string;
  notifiedRoles: string[];
  message?: string;
  errorMessage?: string;
}

export interface ProposalStatusHistory {
  id: number;
  proposalId: number;
  fromStatus: FreelancerProposalStatus;
  toStatus: FreelancerProposalStatus;
  action: ProposalWorkflowAction;
  changedByUserId: number;
  changedByUserName?: string;
  reason?: string;
  changedAt: Date;
  castingProposedSlots?: string;
  revisionRequestMessage?: string;
  hasContentChanges?: boolean;
}

export interface ExecuteWorkflowActionRequest {
  proposalId: number;
  action: ProposalWorkflowAction;
  reason?: string;
  message?: string;

  // Freelancer decline
  freelancerDeclineReason?: number;
  freelancerDeclineReasonDetails?: string;

  // Client decline
  clientDeclineReason?: number;
  clientDeclineReasonDetails?: string;

  // Casting
  castingProposedSlots?: string;

  // Content changes
  hasContentChanges?: boolean;
}

export interface AvailableActionsResponse {
  actions: ProposalWorkflowAction[];
  currentStatus: FreelancerProposalStatus;
}

export interface CanViewProposalResponse {
  canView: boolean;
  reason?: string;
}

export interface BulkTransmitResult {
  successCount: number;
  totalCount: number;
  results: WorkflowTransitionResult[];
}